import ApplicationController from './application_controller'
import { captureClickIds } from '../lib/ad_attribution'
import { marketingConsentGranted } from '../lib/marketing_consent'

// On connect: if marketing consent is granted, capture click IDs to sessionStorage
// and self-remove. Otherwise stay mounted and run once when 'marketing-consent:granted'
// fires. Same-origin now, so the local grant is read directly — no cross-domain carry.
export default class extends ApplicationController {
  connect() {
    if (marketingConsentGranted()) {
      this.run()
      return
    }
    this._onGrant = () => this.run()
    document.addEventListener('marketing-consent:granted', this._onGrant, { once: true })
  }

  disconnect() {
    if (this._onGrant) document.removeEventListener('marketing-consent:granted', this._onGrant)
  }

  run() {
    try {
      captureClickIds()
    } catch (error) {
      this.reportError(error, { source: 'ad_attribution_capture' })
    } finally {
      this.element.remove() // remove ONLY here — never on the bail path
    }
  }
}
